import React from "react";

import { Text } from "@performyard/py-components";
import { Timeframe } from "@performyard/service-contracts";

import { TIMEFRAME_OPTIONS } from "../config";

type TimeframeToggleProps = {
	value: Timeframe;
	onChange: (value: Timeframe) => void;
};

export const TimeframeToggle = ({ value, onChange }: TimeframeToggleProps) => (
	<div className="flex items-center" role="group" aria-label="Timeframe" data-testid="insights-timeframe">
		{TIMEFRAME_OPTIONS.map((option) => (
			<button
				key={option.value}
				type="button"
				className={`-ml-px flex items-center justify-center border border-solid border-neutral-3 p-2 first:ml-0 first:rounded-l last:rounded-r ${
					option.value === value ? "bg-neutral-2" : "bg-neutral-0"
				}`}
				aria-pressed={option.value === value}
				onClick={() => onChange(option.value)}
				data-testid={`insights-timeframe-${option.value}`}
			>
				<Text size="paragraph-3" weight="semi-bold" color="primary-9" wrap={false}>
					{option.label}
				</Text>
			</button>
		))}
	</div>
);
